import * as React from 'react';
import { SVGProps } from 'react';

const IconHealthSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10zM5 5V3h2v2h2v2H7v2H5V7H3V5h2z"
    />
  </svg>
);
export default IconHealthSizeXs;
